import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_PAYMENTS_OUTSTANDING_BILLS_ALL_CLUSTERS_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpPartialSuccess, hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { ApiStatusType, GenericApiResponse } from '@shared/utils/api/types';

import type { GetAllClusterBillsPayload, GetAllClusterBillsResult } from '../types/getAllClusterBills.types';

export const CLUSTER_BILLS = 'ClusterBills';

interface GetAllClusterBillsTransformedResult extends GetAllClusterBillsResult {
  message: string;
  status: ApiStatusType;
}

export const getAllClusterBills = (builder: BuilderType) =>
  builder.query<GetAllClusterBillsTransformedResult, GetAllClusterBillsPayload>({
    keepUnusedDataFor: 0,
    providesTags: [CLUSTER_BILLS],
    query: (data) => ({
      data,
      method: 'POST',
      url: GET_PAYMENTS_OUTSTANDING_BILLS_ALL_CLUSTERS_URL,
    }),
    transformResponse: (response: GenericApiResponse<GetAllClusterBillsTransformedResult>) => {
      if (hasCcdpSuccess(response) || hasCcdpPartialSuccess(response)) {
        return {
          ...response.Result,
          message: response.Message,
          status: response.Status,
        } as GetAllClusterBillsTransformedResult;
      }
      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
